module.exports = __webpack_public_path__ + "img/photos.5fcf05e6.png";